import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import TagManager from 'react-gtm-module';
import LogRocket from 'logrocket';

if(process.env.NODE_ENV === "production") {
    if(process.env.REACT_APP_RELEASE) {
        LogRocket.init(process.env.REACT_APP_ID_LOGROCKET!, {
            release: process.env.REACT_APP_RELEASE
        });
    } else {
        console.warn("LogRocket is not functionnal because the variable REACT_APP_RELEASE is undefined");
    }
}


const tagManagerArgs = {
    gtmId: 'GTM-W56WWFM'
}
TagManager.initialize(tagManagerArgs);

// Setup fontawesome
require('./assets/fontawesomeSetup');

async function bootstrap() {
    const BootStrapper = (await import('./AuthenticationComponent')).default;
    ReactDOM.render(<BootStrapper />, document.getElementById('root')); 
}

bootstrap();

